import gql from 'graphql-tag';
import { errorsTypeDef } from '../../errors/errors-type-def';
import { taskListTaskServiceTypeDef } from '../definitions/task-list/task-list-task-service-type-def';

const taskListQuery = gql`
  query TaskList(
    $searchText: String,
    $states: [String!],
    $onlyMy: Boolean,
    $offset: Int,
    $limit: Int,
    $orderDesc: Boolean,
    $orderBy: [String!],
    $orderByConst: String
  ) {
    task {
      list(input: {
        searchText: $searchText
        states: $states
        onlyMy: $onlyMy
        offset: $offset
        limit: $limit
        orderDesc: $orderDesc
        orderBy: $orderBy
        orderByConst: $orderByConst
      }) {
        output {
          totalCount
          rows {
            ${taskListTaskServiceTypeDef}
          }
        }
        errors {
          ${errorsTypeDef}
        }
      }
    }
  }`;

export default taskListQuery;
